/**
 * Activity Heatmap & Cognitive Horizon Calculator
 * Aggregates 52 weeks of archive activity, clicks, and reading velocity
 */

export function calculateActivityHeatmap(bookmarks = []) {
  const dayCounts = {};
  let totalClicks = 0;

  // Tally clicks and creation timestamps
  bookmarks.forEach((b) => {
    totalClicks += b.clicks || 0;
    if (b.lastVisited) {
      const day = new Date(b.lastVisited).toISOString().slice(0, 10);
      dayCounts[day] = (dayCounts[day] || 0) + (b.clicks || 1);
    }
    if (b.createdAt) {
      const day = new Date(b.createdAt).toISOString().slice(0, 10);
      dayCounts[day] = (dayCounts[day] || 0) + 1;
    }
  });

  // Build 52 weeks (364 days) leading up to today
  const weeks = [];
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 is Sunday

  // End on the current day's Saturday
  const endDate = new Date(today);
  endDate.setDate(today.getDate() + (6 - dayOfWeek));

  const startDate = new Date(endDate);
  startDate.setDate(endDate.getDate() - (52 * 7 - 1));

  let currentStreak = 0;
  let maxStreak = 0;
  let tempStreak = 0;

  let iterDate = new Date(startDate);
  for (let w = 0; w < 52; w++) {
    const week = [];
    for (let d = 0; d < 7; d++) {
      const dateStr = iterDate.toISOString().slice(0, 10);
      const count = dayCounts[dateStr] || 0;

      // Intensity level 0 - 4
      let level = 0;
      if (count > 0 && count <= 2) level = 1;
      else if (count > 2 && count <= 5) level = 2;
      else if (count > 5 && count <= 10) level = 3;
      else if (count > 10) level = 4;

      week.push({ date: dateStr, count, level });

      // Streak tally
      if (count > 0) {
        tempStreak++;
        if (tempStreak > maxStreak) maxStreak = tempStreak;
      } else {
        tempStreak = 0;
      }

      iterDate.setDate(iterDate.getDate() + 1);
    }
    weeks.push(week);
  }

  return {
    weeks,
    totalClicks,
    totalBookmarks: bookmarks.length,
    maxStreak,
    activeDays: Object.keys(dayCounts).length,
  };
}
